import getFullBoughtTalents from "./GetFullBoughtTalents";
import findNestedProperty from "./FindNestedProperty";
import modStateKey from "./ModStateKey"
import talentsData from "../data/talents.json"
import characteristicsData from "../data/characteristics.json"
import applyTalentChoices from "./ApplyTalentChoices"
import computeForceRating from "./ComputeForceRating"
import { getEffective } from "./applyHomebrew"

const DiceModifiers = (character, handleCharacterChange, forcePowers, forceAbilities, skills) => {
  const talents = getEffective('talents', talentsData);
  const { Bought: boughtTalents, universalForce } = getFullBoughtTalents(character);
  const choiceEffects = applyTalentChoices(character, boughtTalents, skills, talents);

  const getExtraCareerSkills = () => {
    let extraCareerSkills = [];
    if (character.Specializations[1]) {
      character.Specializations.forEach((s) => {
        if (s.CareerSkills) {
          extraCareerSkills.push.apply(extraCareerSkills, s.CareerSkills.Key);
        }
      });
    }
    boughtTalents.forEach((t) => {
      if (t.data && t.data.ChooseCareerSkills && t.data.ChooseCareerSkills.NewSkills) {
        if (Array.isArray(t.data.ChooseCareerSkills.NewSkills.Key)) {
          for (let s in t.data.ChooseCareerSkills.NewSkills.Key) {
            extraCareerSkills.push(
              skills.find(
                (sk) => sk.Key === t.data.ChooseCareerSkills.NewSkills.Key[s],
              ).skill,
            );
          }
        } else {
          extraCareerSkills.push(
            skills.find(
              (sk) => sk.Key === t.data.ChooseCareerSkills.NewSkills.Key,
            ).skill,
          );
        }
      }
    });
    return extraCareerSkills;
  };

  const extraCareerSkills = getExtraCareerSkills().concat(choiceEffects.extraCareerSkills);
  if (!_.isEqual(extraCareerSkills, character.ExtraCareerSkills)) {
    handleCharacterChange({ ExtraCareerSkills: extraCareerSkills });
  }

  function getFullBoughtPowers() {
    const boughtPowers = [];
    const powerMap = {};

    for (let key in character.ForcePowers) {
      let power = forcePowers.find((p) => p.Key === key);
      if (!power) continue;
      power.BoughtPowers = character.ForcePowers[key];
      if (!power.AbilityRows) {
        return [];
      }
      power.AbilityRows.forEach((row, rowIndex) => {
        row.Abilities.forEach((powerKey, index) => {
          if (power.BoughtPowers[rowIndex] && power.BoughtPowers[rowIndex][index]) {
            if (!powerMap[powerKey]) {
              const powerData = forceAbilities.find((p) => p.Key === powerKey);
              powerMap[powerKey] = powerData;
            }

            const existingPower = boughtPowers.find((p) => p.key === powerKey);
            if (existingPower) {
              existingPower.count++;
            } else {
              boughtPowers.push({
                key: powerKey,
                data: powerMap[powerKey],
                count: 1,
              });
            }
          }
        });
      });
    }
    return boughtPowers;
  }

  const newForceRating = computeForceRating(boughtTalents, {
    universalForce,
    careerHasFR: !!(character.Career.Attributes && character.Career.Attributes.ForceRating),
    shortPath: !!(character.Extras && character.Extras.ShortPath),
  });
  if (newForceRating != character.ForceRating) {
    handleCharacterChange({ ForceRating: newForceRating });
  }

  let weapons = character.Weapons;
  let armor = character.Armor;
  let gear = character.Gear;
  let boughtPowers = getFullBoughtPowers();
  let species = character.Species;
  let modifiers = [];

  function parseMods(mods) {
    if (mods[0]) {
      for (let m in mods) {
        let mod = mods[m];
        if (mod.DieModifiers) {
          if (mod.DieModifiers[0]) {
            for (let dm in mod.DieModifiers) {
              modifiers.push(mod.DieModifiers[dm]);
            }
          } else {
            modifiers.push(mod.DieModifiers);
          }
        }
      }
    } else {
      if (mods.DieModifiers) {
        if (mods.DieModifiers[0]) {
          for (let dm in mods.DieModifiers) {
            modifiers.push(mods.DieModifiers[dm]);
          }
        } else if (mods.DieModifiers.SkillKey) {
          modifiers.push(mods.DieModifiers);
        } else if (mods.DieModifiers[0]) {
          for (let dm in mods.DieModifiers) {
            modifiers.push(mods.DieModifiers[dm]);
          }
        } else {
          modifiers.push(mods.DieModifiers);
        }
      }
    }
  }

  if (character.Extras?.Reputation) {
    let reputation = parseInt(character.Extras.Reputation)
    if (reputation > 0) {
      parseMods({ DieModifiers: [{ SkillKey: 'CHARM', BoostCount: reputation }, { SkillKey: 'NEG', BoostCount: reputation }, { SkillKey: 'COERC', AddSetbackCount: reputation }] })
    }
    if (reputation < 0) {
      reputation = Math.abs(reputation)
      parseMods({ DieModifiers: [{ SkillKey: 'CHARM', AddSetbackCount: reputation }, { SkillKey: 'NEG', AddSetbackCount: reputation }, { SkillKey: 'COERC', BoostCount: reputation }] })
    }
  }

  const parseBaseMods = (baseMods) => {
    if (!baseMods) return
    if (baseMods.DieModifiers) {
      parseMods(baseMods);
    } else if (Array.isArray(baseMods)) {
      for (let m in baseMods) {
        if (baseMods[m].DieModifiers) {
          parseMods(baseMods[m]);
        }
      }
    }
  }

  const parseEquipped = (items) => {
    for (let i in items) {
      const item = items[i]
      if (!item.Equipped) continue
      parseBaseMods(item.BaseMods)
      for (let at in item.Attachments || []) {
        let attachment = item.Attachments[at]
        parseBaseMods(attachment.BaseMods)
        for (let m in attachment.AddedMods || []) {
          let mod = attachment.AddedMods[m]
          if (mod.DieModifiers && item.ModStates) {
            let modded = item.ModStates[modStateKey(item.inventoryID, attachment.Key, mod, m)]
            const trueCount = modded ? modded.installed.filter(value => value === true).length : 0
            for (let n = 0; n < trueCount; n++) {
              parseMods(mod);
            }
          }
        }
      }
    }
  }

  parseEquipped(weapons)
  parseEquipped(armor)
  parseEquipped(gear)

  for (let t in boughtTalents) {
    let data = JSON.parse(JSON.stringify(talents.find((tal) => boughtTalents[t].key === tal.Key)))
    if (data.DieModifiers) {
      let countType = Object.keys(data.DieModifiers)[1];
      if (!Array.isArray(data.DieModifiers) && countType && countType.includes("Count")) {
        data.DieModifiers[countType] = parseInt(data.DieModifiers[countType]) * boughtTalents[t].count
        parseMods(data)
      } else if (Array.isArray(data.DieModifiers)) {
        data.DieModifiers.forEach(modifier => {
          countType = Object.keys(modifier)[1];
          if (countType && countType.includes("Count")) {
            modifier[countType] = boughtTalents[t].count || 1
          }
        });
        parseMods(data);
      }
      else {
        parseMods(data);
      }
    }
  }

  for (let p in boughtPowers) {
    let data = boughtPowers[p].data;
    if (data.DieModifiers) {
      parseMods(data);
    }
  }


  if (species.OptionChoices && species.OptionChoices[0]) {
    for (let o in species.OptionChoices) {
      if (species.OptionChoices[o].Options.DieModifiers) {
        parseMods(species.OptionChoices[o].Options);
      }
      if (Array.isArray(species.OptionChoices[o].Options)) {
        for (let op in species.OptionChoices[o].Options) {
          let opt = species.OptionChoices[o].Options[op]
          if (opt.DieModifiers) {
            parseMods(opt);
          }
        }
      }
    }
  } else if (
    species.OptionChoices &&
    species.OptionChoices.Options &&
    species.OptionChoices.Options.DieModifiers
  ) {
    parseMods(species.OptionChoices.Options);
  }

  if (species.SubSpeciesList && species.SubSpecies) {
    let selectedSS = species.SubSpeciesList.find((ss) => ss.Key === species.SubSpecies)
    if (selectedSS.OptionChoices && selectedSS.OptionChoices[0]) {
      for (let o in selectedSS.OptionChoices) {
        if (selectedSS.OptionChoices[o].Options.DieModifiers) {
          parseMods(selectedSS.OptionChoices[o].Options);
        }
        if (Array.isArray(selectedSS.OptionChoices[o].Options)) {
          for (let op in selectedSS.OptionChoices[o].Options) {
            let opt = selectedSS.OptionChoices[o].Options[op]
            if (opt.DieModifiers && selectedSS.OptionChoices[o].Selected === opt.Key) {
              parseMods(opt);
            }
          }
        }
      }
    } else if (
      selectedSS.OptionChoices &&
      selectedSS.OptionChoices.Options.DieModifiers
    ) {
      parseMods(selectedSS.OptionChoices.Options);
    }
  }

  choiceEffects.dieModifiers.forEach((m) => modifiers.push(m));

  const expandedModifiers = [];
  for (const item of modifiers) {
    if (item.SkillKey || (!item.SkillType && !item.SkillChar)) {
      const { SkillKey, SkillType, SkillChar, ...counts } = item;
      if (SkillKey && SkillChar) {
        const charName = characteristicsData.find((c) => c.Key === SkillChar)?.Name;
        const usedChar = character.Skills?.find((s) => s.Key === SkillKey)?.ModChar || skills.find((s) => s.Key === SkillKey)?.characteristic;
        if (usedChar !== charName) { continue; }
      }
      Object.keys(counts).forEach((ck) => expandedModifiers.push({ SkillKey, [ck]: counts[ck] }));
      continue;
    }
    let matchSkills = [];
    if (item.SkillType) {
      matchSkills = skills.filter((s) => s.type === item.SkillType);
    } else if (item.SkillChar) {
      const charName = characteristicsData.find((c) => c.Key === item.SkillChar)?.Name;
      matchSkills = skills.filter((s) => s.characteristic === charName);
    }
    if (matchSkills.length === 0) {
      continue;
    }
    const { SkillKey, SkillType, SkillChar, ...counts } = item;
    const countKeys = Object.keys(counts);
    matchSkills.forEach((s) => {
      countKeys.forEach((ck) => expandedModifiers.push({ SkillKey: s.Key, [ck]: counts[ck] }));
    });
  }

  const skillMods = new Map();
  for (const item of expandedModifiers) {
    const skillKey = item.SkillKey;
    const countType = Object.keys(item)[1];
    const modCount = parseInt(item[countType], 10);

    if (skillMods.has(skillKey)) {
      const existingBoosts = skillMods.get(skillKey);
      existingBoosts[countType] = (existingBoosts[countType] || 0) + modCount;
    } else {
      skillMods.set(skillKey, { [countType]: modCount });
    }
  }

  const mergedData = Array.from(skillMods.entries()).map(([key, value]) => ({
    SkillKey: key,
    ...value,
  }));

  return mergedData;
};
export default DiceModifiers;
